import React, {useEffect, useState} from 'react';
import {Control, useWatch} from 'react-hook-form';
import {IconButton, Stack, Tooltip} from '@mui/material';
import {AsyncSelect, Button, ControlledTextField} from '../../../../../components/forms';
import {EntityWithIdAndDescriptionFields} from '../../../../../types';
import {OperacionLCLSFields} from "../types/fields";
import {OperacionLCLSLimiteTipo} from "../types/dto";
import MenuIcon from '@mui/icons-material/Menu';

interface OperacionLCLSCampoLimiteProps {
    control: Control<any>;
    name: string;
    label: string;
    loadOptions: () => Promise<OperacionLCLSLimiteTipo[]>;
    onModeChange?: (isFreeSolo: boolean) => void;
    disabled?: boolean;
    buttonType?: 'standard' | 'icon';
}

export const OperacionLCLSCampoLimite = ({
                                             control,
                                             name,
                                             label,
                                             loadOptions,
                                             onModeChange,
                                             disabled,
                                             buttonType = 'standard'
                                         }: OperacionLCLSCampoLimiteProps) => {
    const fieldValue = useWatch({control, name});

    const [isFreeSolo, setIsFreeSolo] = useState<boolean | undefined>(undefined);

    // este useEffect es para poner el input en modo freeSolo si el valor actual no es una de las opciones
    useEffect(() => {
        const initialValue = control._formValues[name];

        if (initialValue === null || initialValue === undefined) {
            setIsFreeSolo(false);
            if (onModeChange) onModeChange(false);

            return;
        }

        loadOptions().then(allOptions => {
            const valueExists = allOptions.some(
                option => option[OperacionLCLSFields.Monto] === initialValue
            );

            const shouldBeFreeSolo = !valueExists;
            setIsFreeSolo(shouldBeFreeSolo);
            if (onModeChange) onModeChange(shouldBeFreeSolo);
        });
    }, []);

    useEffect(() => {
        if (isFreeSolo === undefined) return;

        if (fieldValue === null) {
            setIsFreeSolo(true);
            onModeChange && onModeChange(true);
        }
    }, [fieldValue, onModeChange]);

    const renderToggleButton = () => {
        const commonProps = {
            size: 'small',
            color: 'primary',
            onClick: () => {
                setIsFreeSolo(false);
                onModeChange && onModeChange(false);
            },
            disabled: disabled
        } as const;

        if (buttonType === 'icon') {
            return (
                <Tooltip title="Ver opciones">
                    <span>
                        <IconButton {...commonProps}>
                            <MenuIcon fontSize="small"/>
                        </IconButton>
                    </span>
                </Tooltip>
            );
        }

        return (
            <Button {...commonProps}>
                Opciones
            </Button>
        );
    };

    if (!isFreeSolo) {
        return (
            <AsyncSelect
                control={control}
                name={name}
                label={label}
                loadOptions={loadOptions}
                fullWidth
                nullOptionLabel={'Otro'}
                valueField={OperacionLCLSFields.Monto}
                descriptionField={EntityWithIdAndDescriptionFields.Description}
                disabled={disabled}
                optionPrefix={'USD '}
            />
        );
    }

    return (
        <Stack direction={'row'} gap={1} alignItems="center">
            <ControlledTextField
                name={name}
                label={label}
                control={control}
                size='small'
                autoFocus
                currency
                prefix={'USD'}
                fullWidth
                disabled={disabled}

            />
            {renderToggleButton()}
        </Stack>
    );
};